import { Injectable } from '@angular/core';
import { Map } from 'mapbox-gl';
import { MapService } from 'src/app/shared/components/map/map.service';
import { Simulation } from 'src/app/simulation/state/simulation.model';
import { SimulationQuery } from 'src/app/simulation/state/simulation.query';

@Injectable({
  providedIn: 'root'
})
export class BuildingClassificationLayerService {

  minCollectiveHorizontal: number;
  minCollectiveVertical: number;

  constructor(
    private simulationQuery: SimulationQuery,
    private mapService: MapService
  ) {
  }

  public load() {
    this.mapService.map$.subscribe(mapbox => {
      this.listenClassificatioOfCollective(mapbox);
    });
  }

  private listenClassificatioOfCollective(mapbox: Map) {
    this.simulationQuery.active$.subscribe(simulation => {

      if (simulation) {
        if (!this.hasClassification(simulation)) {
          return;
        }
        if (!this.classificationHasChanged(simulation)) {
          return;
        }

        let visibible = false;
        if (mapbox.getLayer(LAYER_ID)) {
          visibible = mapbox.getLayoutProperty(LAYER_ID, 'visibility') === 'visible';
          mapbox.removeLayer(LAYER_ID);
        }

        this.addLayer(mapbox, simulation, visibible);

      } else if (mapbox.getLayer(LAYER_ID)) {
        this.minCollectiveHorizontal = null;
        this.minCollectiveVertical = null;
        mapbox.removeLayer(LAYER_ID);
      }
    });
  }

  private hasClassification(simulation: Simulation): boolean {
    return simulation.min_collective_horiz > 0 && simulation.min_collective_vert > 0;
  }

  private classificationHasChanged(simulation: Simulation): boolean {
    if (simulation.min_collective_horiz !== this.minCollectiveHorizontal) {
      return true;
    }
    return simulation.min_collective_horiz !== this.minCollectiveVertical;
  }

  private addLayer(mapbox: Map, simulation: Simulation, visibible: boolean) {
    this.minCollectiveHorizontal = simulation.min_collective_horiz;
    this.minCollectiveVertical = simulation.min_collective_vert;

    mapbox.addLayer(this.createLayer(visibible));
  }

  private createLayer(visibible: boolean): mapboxgl.Layer {

    return {
      id: LAYER_ID,
      source: 'mitra-building',
      type: 'line',
      layout: {
        visibility: visibible ? 'visible' : 'none'
      },
      paint: {
        'line-color':
          [
            'case',
            ['==', ['get', 'occupancy'], 'Individual'],
            '#29522f',
            // Collective
            ['all', ['==', ['get', 'orientation'], 'Horizontal'], ['>=', ['get', 'units'], this.minCollectiveHorizontal]],
            '#805740',
            ['all', ['==', ['get', 'orientation'], 'Vertical'], ['>=', ['get', 'units'], this.minCollectiveVertical]],
            '#6441b9',
            // Not classified as Collective
            '#29522f'
          ],
        'line-width': [
          'interpolate',
          ['exponential', 2],
          ['zoom'],
          1,
          1,
          22,
          400
        ],
      }
    } as mapboxgl.Layer;
  }
}

const LAYER_ID = 'mitra-building-classification';
